import React, { useRef } from 'react'
import { PropertyHandlers } from '../state/actions';
import { DraggerComp } from "../../Common/components/DraggerComp";
import { useDispatch } from 'react-redux';

export default function PropertyDocsDragger({handleClose, item, section, additionalData={}, origin}) {
    const delegate = (section === "DELEGATE");
    const bos = (section === "BOS");
    const uploadFile = useRef("");
    const dispatch = useDispatch();
    const agentDetails = (item?.currentAgentId);
    //    Function to Upload doc will be passed as prop
    const uploadTemp = (uploadedFilesInfo) => {
        const payload = {
            fileLinks: uploadedFilesInfo, // must be an array of { fileLink, fileName, fileType }
            personId: agentDetails?._id,
            openFor: item?.isProperty ? "SELLER_AGENT" : "BUYER_AGENT",
            folderOf: "property_docs",
            ...additionalData
        };
        
        if (item?.offerId) {
            payload.offerId = item.offerId;
        }
        
        if (delegate) {
            payload.delegateSide = item.isProperty ? "SELLER" : "BUYER";
            payload.delegateOwnerId = agentDetails?._id;
        } 
        else if(bos){
            payload.screenType = "BOS";
            payload.delegateOwnerId = agentDetails?._id;
        }
        
        if (item?.isProperty) {
            payload.propertyId = item._id;
        }
        
        dispatch(PropertyHandlers.uploadPropertyDocsFun(payload));
        if(handleClose){
            handleClose();
        }
    };
    return (
        <div style={{width:"100%",margin:"auto",marginTop:"20px",display:"flex",justifyContent:"center"}}>
            <DraggerComp
                uploadFile={uploadFile}
                uploadTemp={uploadTemp}
                accept=".pdf,.PDF,image/*"
                origin={origin}
            />
        </div>
    )
}
